import moment from 'moment';
import {
  _templateExecutor,
  convertToBrakes,
  executeSvg,
  limitWord,
  executeLink,
  executeImageFactory,
} from '.';
import 'moment/locale/uk';
import 'moment/locale/ru';
import 'moment/locale/en-gb';
import _ from 'lodash';
import cloneDeep from 'lodash/cloneDeep';
import { AnswerEnvironmentState, SubmissionEnvironmentState } from '@types';
import { LangEnum, ImageShape, ConfigKeys } from '@enums';

export const renderAnswer = (env: AnswerEnvironmentState, template: string, id: string) => {
  const answerHtml = new HtmlGenerator(template, env);
  answerHtml.renderHtml(id);
};

export class HtmlGenerator {
  private readonly _template;
  private readonly _env;
  constructor(
    template: string,
    environment: Partial<SubmissionEnvironmentState | AnswerEnvironmentState>,
    isCalendar = false,
    originSections = []
  ) {
    const lang = environment.lang;
    if (lang.toLowerCase() === LangEnum.RU) {
      moment.locale('ru');
    } else {
      moment.locale('en-gb');
    }
    this._template = template;
    this._env = cloneDeep({
      scale: 1,
      ...environment,
      moment,
      _: _,
      convertToBrakes,
      executeImage: executeImageFactory(isCalendar),
      executeSvg,
      limitWord,
      executeLink,
      origin: window.location.origin,
      ImageShape,
      ConfigKeys,
      originSections,
    });
  }
  renderHtml(selector = '#message') {
    const result: Element = document.querySelector(selector);
    result.innerHTML = _templateExecutor(this._template)(this._env);
  }

  getHtml(download = false) {
    this._env.isDownload = download;
    return _templateExecutor(this._template)(this._env);
  }
}
